<template>
  <v-container justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="flex-column" style="margin-top: 0;">
    <v-layout row wrap class="flex-none" align-items-center>
      <div>
        <div style="max-width: 350px">
          <p class="grey--text text--darken-1" style="font-size: 16px;">
            {{ $t('signature.selec_lang') }}
          </p>
          <v-autocomplete
            :items="$t('signature.langs')"
            item-text="name"
            item-value="code"
            hide-details
            v-model="langSelected"
            style="margin-bottom: 50px;"
          ></v-autocomplete>
        </div>
        <h1 class="display-1 grey--text text--darken-1">{{ $t('signature.terms_title') }}</h1>
        <p class="mt-4 mb-0 grey--text text--darken-1" style="font-size: 16px;" v-html="$t('signature.terms_body')">
        </p>
        <div class="mt-4 pt-4">
          <p class="grey--text text--darken-1" style="font-size: 16px;">
            {{ $t('signature.guests_list') }}
          </p>
          <v-checkbox
            v-for="(guest, i) in guests"
            :key="i"
            :value="guest"
            :label="`${guest.profile.name || ''} ${guest.profile.lastName || ''} - ${guest.room ? $t('signature.room', { name: guest.room.name }) : $t('signature.no_room')}`"
            hide-details
            v-model="guestsSelected"
          />
        </div>
        <div class="mt-4 pt-4" style="max-width: 350px" >
          <p class="mb-0 grey--text text--darken-1" style="font-size: 16px;">
            {{ $t('signature.guest_selected') }}
          </p>
          <v-select
            color="accent"
            :items="guests"
            item-value="id"
            :item-text="g => `${g.profile.name || ''} ${g.profile.lastName || ''} - ${g.room ? $t('signature.room', { name: g.room.name }) : $t('signature.no_room')}`"
            hide-details
            v-model="signedBy"
          />
        </div>
        <v-flex class="d-flex mt-4 pt-4" style="width: 500px" >
          <div>
            <p class="mb-4 mb-0 grey--text text--darken-1" style="font-size: 16px;">
              {{ $t('signature.sign_acceptance') }}
            </p>
            <VueSignaturePad
              height="200px"
              ref="signaturePad"
              :customStyle="{
                'border': '2px solid rgba(0,0,0,.54)',
                'border-radius': '4px',
                'padding': 0,
                'margin': 0
              }"
              saveType="image/svg+xml"
              :options="{ onBegin }"
            />
          <div class="d-flex mt-4">
            <v-btn large @click="reset">{{ $t('actions.reset') }}</v-btn>
            <v-btn :loading="loading" large color="primary" @click="submit" :disabled="!guestsSelected.length || !signedBy || isSignatureEmtpy">{{ $t('actions.submit') }}</v-btn>
          </div>
          </div>
        </v-flex>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import VueSignaturePad from 'vue-signature-pad'
import { PANEL_LOCATION } from '@/config/environment'

Vue.use(VueSignaturePad)

export default {
  data () {
    return {
      bookingId: null,
      stationId: null,
      guestsSelected: [],
      signedBy: false,
      isSignatureEmtpy: true,
      langSelected: this.$i18n.locale,
      loading: false
    }
  },
  computed: {
    ...mapState(['guests'])
  },
  methods: {
    reset () {
      this.$refs.signaturePad.clearSignature()
      this.isSignatureEmtpy = true
    },
    submit () {
      this.loading = true
      const { data } = this.$refs.signaturePad.saveSignature()
      const svgBase64 = data.split('base64,')[1]
      const svgDecoded = atob(svgBase64)
      this.$store.dispatch('saveSignature', {
        signedBy: this.signedBy,
        allowedGuests: this.guestsSelected.map(guest => guest.id),
        signatureImage: svgDecoded,
        stationId: this.stationId })
        .then(() => {
          if (window.opener) {
            window.opener.postMessage('refreshData', PANEL_LOCATION)
            window.close()
          }
          this.$store.commit('setMessage', { text: this.$t('message.complete_main'), color: 'success', timeout: 0 })
        })
        .catch(() => {
          this.loading = false
        })
    },
    onBegin () {
      this.isSignatureEmtpy = false
    }
  },
  created () {
    this.$store.commit('setToken', this.$route.params.token)
    this.bookingId = this.$route.query.booking_id !== 'null' ? this.$route.query.booking_id : null
    this.stationId = this.$route.query.station_id !== 'null' ? this.$route.query.station_id : null

    if (this.bookingId !== undefined) {
      this.$store.dispatch('getBookingGuestsForSignature', this.bookingId).catch(() => {})
    }
  },
  watch: {
    langSelected (code) {
      this.$i18n.locale = code
    }
  }
}
</script>
